import React from 'react';
import CaseView from '../components/CaseView';
import CaseAssesor from '../components/CaseAssesor';
import DataFolderArea from '../components/DataFolderArea';
import Navbar from '../components/Navbar';
// import SharePointArea from '../components/SharePointArea';
import { Link } from 'react-router-dom';
import DocumentsSharepoint from '../components/DocumentsSharepoint';

export default function Case(props) {

    return (
        <div>
            <Navbar />

            <div className="container mt-5 mb-5">
                <div className="row">
                    <div className="col-md-12">
                        <CaseView id={props.match.params.id}  />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-8">
                        <br /><br />
                        {/* <h2>Checklist</h2> */}
                        {/* <CaseAssesor id={props.match.params.id} ></CaseAssesor>  */}

                        <h2>Files</h2>
                        <DataFolderArea caseId={props.match.params.id} ></DataFolderArea> 
                        <br /><br />

                    </div>
                </div>

                {/* <h2 className="mt-4">Sharepoint</h2>
                <DocumentsSharepoint caseId={props.match.params.id}></DocumentsSharepoint> */}


            </div>


        </div>
    );
}